﻿import { response_booking_info_payment } from "./response_booking_info_payment";

export class response_booking_info {
    public reservation_app_id: string = "";
    public company_identifier: string = "";
    public finance_centre_identifier: string = "";
    public sales_user: string = "";
    public iso_currency_code: string = "";
    public booking_type: string = "";
    public booking_identifier: string = "";
    public payment: response_booking_info_payment = new response_booking_info_payment();
}